/* eslint-disable */
// This file is manually created. Frontend uses this file to dynamically authorize users from
// multiple userpools.

const awsmobile = {
  codelos: {
    aws_project_region: 'eu-central-1',
    aws_cognito_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_ne60s9DQy',
    aws_user_pools_web_client_id: '61nps3sbkg5vcrn4vl5hduqbf4',
    oauth: {},
    aws_content_delivery_bucket:
      'loadlab-20200707181540-hostingbucket-appcodelos',
    aws_content_delivery_bucket_region: 'eu-central-1',
    aws_content_delivery_url: 'https://d3160dcu7gh2s6.cloudfront.net',
  },
  teamenergie: {
    aws_project_region: 'eu-central-1',
    aws_cognito_region: 'eu-central-1',
    aws_user_pools_id: 'eu-central-1_AvdSNCrEo',
    aws_user_pools_web_client_id: '4qebeckf63k9fhqd29irlcgupa',
    oauth: {},
    aws_content_delivery_bucket:
      'loadlab-20200707181540-hostingbucket-appcodelos',
    aws_content_delivery_bucket_region: 'eu-central-1',
    aws_content_delivery_url: 'https://d3160dcu7gh2s6.cloudfront.net',
  },
};

export default awsmobile;
